/* __next_internal_client_entry_do_not_use__ FaireLogo auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var getImageSrc = function(mobileSmallest, mobileSmall, simple, inverse) {
    if (mobileSmallest) {
        return "https://cdn.faire.com/static/logo-320px.svg";
    } else if (mobileSmall) {
        return "https://cdn.faire.com/static/logo-360px.svg";
    } else if (simple) {
        return "https://cdn.faire.com/static/simpleLogo.svg";
    } else if (inverse) {
        return "https://cdn.faire.com/static/logo-inverse.svg";
    } else {
        return "https://cdn.faire.com/static/logo.svg";
    }
};
export var FaireLogo = function(param) {
    var simple = param.simple, className = param.className, inverse = param.inverse, size = param.size, mobileSmallest = param.mobileSmallest, mobileSmall = param.mobileSmall;
    var src = getImageSrc(mobileSmallest, mobileSmall, simple, inverse);
    return /*#__PURE__*/ _jsx("img", {
        width: size,
        className: className,
        src: src,
        alt: "Faire Logo"
    });
};
